import script from "./SpecialismFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialismFaq.vue?vue&type=script&setup=true&lang=js"

import "./SpecialismFaq.vue?vue&type=style&index=0&id=18bbad50&scoped=true&lang=scss"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18bbad50"]])

export default __exports__